/* eslint-disable no-undef */
import $ from "jquery";

const el = {
  tag: "a.js-tag",
};

const flowboxInstagram = () => {
  const init = (tags = false) => {
    let params = {
      container: "#js-flowbox-flow",
      // eslint-disable-next-line no-undef
      key: flowboxData.apiKey ?? "AT-NsVpaTvyhqXaMIT6AQg",
      locale: "nl",
    };

    if (tags) {
      params.tags = tags;
    }

    window.flowbox("init", params);
  };

  const handleOnClickTag = () => {
    $(document).on("click", el.tag, function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const tags = $(this).data("tag");
      // console.log($(this).data("tag"));
      init(tags);
    });
  };

  init(flowboxData.tag);
  handleOnClickTag();
};

try {
  flowboxInstagram();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
